export enum PrudsysServiceEnum {
  HOMEPAGE = 'homepage',
  CATEGORY_ENTRY = 'category_entry',
  CATEGORY_OVERVIEW = 'category_overview',
  PRODUCT_DETAIL = 'product_detail',
  SEARCH = 'search',
  BASKET = 'basket',
  NOT_FOUND = '404'
}
